import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import { QueryClientProvider } from '@tanstack/react-query'
import 'react-datepicker/dist/react-datepicker.css'
import '@glideapps/glide-data-grid/dist/index.css'

import { firebaseConfig } from '@/firebase.config'
import ErrorBoundary from '@shared/ErrorBoundary'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { setDefaultOptions } from 'date-fns'
import de from 'date-fns/locale/de'
import { initializeApp } from 'firebase/app'
import type { FC } from 'react'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import { BrowserRouter } from 'react-router-dom'
import { queryClient } from './api/queryClient'
import { useGlobalListeners } from './hooks/useGlobalListeners.hook'
import AppRoute from './routes'
import { ThemeProvider } from './theme'

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Set default date-fns options
setDefaultOptions({ locale: de })

// Detect if we're running in a feature branch deployment
const getBasename = () => {
  const path = window.location.pathname
  const featureMatch = path.match(/^\/features\/([^\/]+)/)
  const featureBaseUrl = featureMatch ? `/features/${featureMatch[1]}` : ''
  if (featureBaseUrl === '' && import.meta.env.BASE_URL !== '/') {
    return import.meta.env.BASE_URL
  }
  return featureBaseUrl
}

const App: FC = () => {
  useGlobalListeners()
  // @ts-ignore
  // if (window.visualViewport?.width <= 1100 && !env.isDev && !isBase()) {
  //   return <div>Wir arbeiten gerade an der mobilen Version von ecoplanet. Bitte nutzen Sie aktuell die Desktopversion der Anwendung.</div>
  // }
  return (
    <ThemeProvider>
      <BrowserRouter basename={getBasename()}>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <AppRoute />
            {/* Commented out the budget banner code but kept it here for potential future use. */}
            {/* {isLoggedIn && <BudgetConfigurationBanner />} */}
          </ErrorBoundary>
          <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-left' position='bottom' />
        </QueryClientProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
